import { Button, ModalActions, ModalContent, ModalTitle } from "@kaltura/ds-react-components";
import { useState } from "react";
import CreateTownhallForm, { CreateTownhallFormProps } from "./form/CreateTownhallForm";
import CreateTownhallFormContainer from "./form/CreateTownhallFormContainer";
import { translate } from "@kaltura/ds-react-utils";
import { AddNewMenuModalInjectedProps, ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

export interface CreateTownhallModalProps extends CreateTownhallFormProps, AddNewMenuModalInjectedProps {
    /**
     * URL to fetch templates from (required for live-studio mode)
     */
    templatesUrl?: string;
}

const formId = "create-townhall-form";

/**
 * Create Townhall Modal Content component
 */
export const CreateTownhallModalContent = (props: CreateTownhallModalProps) => {
    const sendButtonAnalytics = useButtonAnalytics();
    const { open, onCancel, templatesUrl, ...formProps } = props;
    const { mode = "kwebcast" } = formProps;

    const [processing, setProcessing] = useState(false);

    const baseClassName = "kms-ds-create-townhall-modal";

    const updateProcessing = (value: boolean) => {
        setProcessing(value);
    };

    const handleCancel = () => {
        // send analytics
        switch (mode) {
            case "kwebcast":
                sendButtonAnalytics("Townhall - cancel", ButtonClickAnalyticsType.CLOSE);
                break;
            case "live-studio":
                sendButtonAnalytics("Live-studio - cancel", ButtonClickAnalyticsType.CLOSE);
                break;
            case "simulive":
                sendButtonAnalytics("Simulive - cancel", ButtonClickAnalyticsType.CLOSE);
                break;
        }
        onCancel();
    };

    // get title by current mode
    let title: string;
    switch (mode) {
        case "kwebcast":
            title = translate("Create town hall");
            break;
        case "live-studio":
            title = translate("Create a Live Studio");
            break;
        case "simulive":
            title = translate("Create pre-recorded session");
            break;
    }

    return (
        <>
            <ModalTitle className={`${baseClassName}-title`}>{title}</ModalTitle>
            <ModalContent className={`${baseClassName}-content`}>
                {open && mode !== "live-studio" && (
                    <CreateTownhallForm {...formProps} formId={formId} updateProcessing={updateProcessing} />
                )}
                {open && mode === "live-studio" && templatesUrl && (
                    <CreateTownhallFormContainer
                        {...formProps}
                        templatesUrl={templatesUrl}
                        formId={formId}
                        updateProcessing={updateProcessing}
                    />
                )}
            </ModalContent>
            <ModalActions className={`${baseClassName}-actions`}>
                <Button
                    onClick={handleCancel}
                    variant={"borderless"}
                    color={"secondary"}
                    className={`${baseClassName}-actions-cancel`}
                >
                    {translate("Cancel")}
                </Button>
                <Button
                    type={"submit"}
                    loading={processing}
                    disabled={processing}
                    className={`${baseClassName}-actions-submit`}
                    form={formId}
                >
                    {translate("Create")}
                </Button>
            </ModalActions>
        </>
    );
};
